import React, { useEffect, useState } from "react";
import { Collapse, Space, Table, Tag } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import NodeRSA from "node-rsa";
function TableContant() {
  const [loading, setLoading] = useState(true);
  const [faq, setFaq] = useState([]);
  const [item, setItem] = useState(true);
  const params = useParams();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  const publicKey = `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2wzqlCphAcUFgYRe9zkL
  zTlRlgFdg2Xjvcpd0DHV1AbccXPer26UiKxJOf0oP9MYqndYATHvEK+KhP565uBP
  9ea+IhE7Su7xmI+yhyf3bAY9Ok6OcnkXSg2v9fxBnkWkSCxmMirW5EYFR47U/C0/
  qtx/4/0YykFBlZ215HsgUoH7ACmzvjwQBGYw8u6EJ6E8fW0KYboTbi4NmmfulXQD
  CAiSITsiCU913cxOFRm8m/uBlNyCPOommYyAA4fX0F3CdfCIDKJA3jK5LwKaS8PT
  MMvOHMoMeAoXAQi0Vw3uT1j8BFB7F4uZpUdbD0x9kmT/o4PhIVvYnv8LNSdoQ/rA
  HQIDAQAB
  -----END PUBLIC KEY-----`;

  function encryptAndSignMessage(message) {
    const second = new NodeRSA(publicKey);
    second.setOptions({ encryptionScheme: "pkcs1" });
    const enc = second.encrypt(message, "base64");
    const encryptedData = {
      data: enc,
    };
    return encryptedData;
  }
  const onChange = (key) => {};
  useEffect(() => {
    const encryptedData = encryptAndSignMessage({
      wallet_address: window.location.href.split("/")[4],
    });

    fetch("https://dev-api.atlaswallet.com/dev/api/v1/wallet/validate_faq", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Aw-Api-Auth": "cd852a1599d929d4fe5546a686a59bca5c1ec3f4",
        Authorization: "Per26UiKxJUoH7A",
      },
      body: JSON.stringify(encryptedData),
    })
      .then((res) => res.json())
      .then((data) => {
        setFaq(data?.data);

        const mainData = data.data.map((el, index) => {
          return {
            key: index,
            label: el.title,
            children: (
              <div className="accordQus">
                <div className="innerQus">
                  {el.faq_question_answers_data.map((question, index) => {
                    return (
                      <p
                        onClick={() =>
                          navigate(`/chat`, {
                            state: {
                              question: question,
                            },
                          })
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {index + 1}. {question.question}
                      </p>
                    );
                  })}
                </div>
              </div>
            ),
          };
        });

        setItems(mainData);
        setLoading(false);
        sessionStorage.setItem("validUser", params.key);
      })
      .catch((err) => {
        navigate("/notFound");
      });
    const script = document.createElement("script");
    script.id = "ze-snippet";
    script.src =
      "https://static.zdassets.com/ekr/snippet.js?key=e15542cb-c56e-46bb-aea3-7930d34263a9";
    document.body.appendChild(script);
  }, []);

  const columns = [
    {
      title: "Table of Contant",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <>
          <p
            style={{ cursor: "pointer", color: "#367cc7", fontSize: "15px" }}
            onClick={() =>
              navigate(`/chat`, {
                state: {
                  data: record?.faq_question_answers_data,
                  walletAddress: params.id,
                  key: params.key,
                  //...values
                },
              })
            }
          >
            {text}
          </p>
        </>
      ),
    },
  ];
  // const items = [
  //   {
  //     key: "1",
  //     label: "Setting up Wallet",
  //     children: (
  //       <div className="accordQus">
  //         <div className="innerQus">
  //           <p onClick={() => navigate(`/chat`)}>How to Create a new wallet</p>
  //           <p>How to import an existing wallet from another app.</p>
  //           <p>How to Create a watch only wallet</p>
  //         </div>
  //       </div>
  //     ),
  //   },
  //   {
  //     key: "2",
  //     label: "Adding or Removing Wallets",
  //     children: <p>sss</p>,
  //   },
  // ];
  return (
    <>
      <div className="zendeskBot">
        <div className="helpCenter">
          <h2>Help Center</h2>
          <div className="accordin">
            {/* <Table
              columns={columns}
              dataSource={faq}
              pagination={false}
              loading={loading}
            /> */}
            <div className="accordin">
              <Collapse
                items={items}
                // defaultActiveKey={['1']}
                onChange={onChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TableContant;
